import React from "react";
import { Link } from "gatsby";

const SaleNotice: React.FC<{ name: string }> = ({ name }) => (
  <p className="m-0 text-clhbid-silver">
    <b>{name}</b> is being offered for sale via online escalating tender by{" "}
    <Link to="/" className="font-medium text-clhbid-orange">
      CLHbid.com
    </Link>
    . Check the website for updates from time to time. The property may be
    viewed by interested registered bidders. Please contact us by email at{" "}
    <a className="font-medium text-clhbid-orange" href="mailto:info@clhbid.com">
      info@clhbid.com
    </a>{" "}
    for an appointment. As a law firm, CLHbid never discloses bidder&apos;s
    names to any party, including the Seller. Only the successful buyer&apos;s
    name is ever disclosed to the Seller as part of the closing process.
  </p>
);

export default SaleNotice;
